/*
 * File: container.ts
 * File Created: 2023-11-27 03:22:24
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-09 09:40:00
 * Modified By: Val Liu
 * -----
 */

import { Config } from "@/../config/default/container";

import "@/containers/CoreUI-White";
// import { CoreUIWhite } from "@/containers/CoreUI-White";
// import "@/containers/CoreUI-Blue";
// import { CoreUIBlue } from "@/containers/CoreUI-Blue";
import { QuaffBlueTheme } from "@/containers/Quaff-Blue";

var config: Config = {
    container: QuaffBlueTheme,
};
export default config;
